/* @flow */
import { fetchApi } from 'utils/ajax';
import type { CallApi } from 'utils/ajax';

export type State = {
  isFetching: bool,
  defs: Array<Object>
}
export type Action = {
  type: string,
  payload: Object
}

export let ENTITY_DEFINITIONS_REQUEST = 'gdc/ENTITY_DEFINITIONS_REQUEST';
export let ENTITY_DEFINITIONS_SUCCESS = 'gdc/ENTITY_DEFINITIONS_SUCCESS';
export let ENTITY_DEFINITIONS_FAILURE = 'gdc/ENTITY_DEFINITIONS_FAILURE';

export type fetchEntitiyDefinitionsArgs = {
  program: string,
  project: string
}

export function fetchEntityDefinitions({
  program, project
}: fetchEntitiyDefinitionsArgs): CallApi {
  return fetchApi({
    types: [ENTITY_DEFINITIONS_REQUEST, ENTITY_DEFINITIONS_SUCCESS, ENTITY_DEFINITIONS_FAILURE],
    endpoint: `${program}/${project}/_dictionary/_all`
  });
}

export default function reducer(state: State = {
  isFetching: false,
  defs: []
}, action: Action): State {
  switch (action.type) {
  case ENTITY_DEFINITIONS_REQUEST:
    return {
      ...state,
      isFetching: true
    };
  case ENTITY_DEFINITIONS_SUCCESS:
    // $FlowIgnore
    let defs = Object.values(action.payload);

    return {
      ...state,
      isFetching: false,
      defs
    };
  case ENTITY_DEFINITIONS_FAILURE:
    return {
      ...state,
      isFetching: false
    };
  default:
    return state;
  }
}
